import { jumpFeishuSupportDesk } from "./jumpFeishuSupportDesk.js";
import { shouldShowFeishuSupportDeskGuide } from "./feishuSupportDeskGuide.js";
let feishuSupportDeskGuideBound = false;
function bindFeishuSupportDeskGuideClick() {
  if (feishuSupportDeskGuideBound)
    return;
  feishuSupportDeskGuideBound = true;
  document.addEventListener("click", (event) => {
    var _a, _b;
    const target = (_b = (_a = event.target) == null ? void 0 : _a.closest) == null ? void 0 : _b.call(_a, "[data-feishu-support-desk-guide]");
    if (!target)
      return;
    event.preventDefault();
    jumpFeishuSupportDesk({
      message: target.getAttribute("data-feishu-support-desk-guide") || ""
    });
  });
}
function buildFeishuSupportDeskGuideHtml(message) {
  const guideMessage = typeof message === "string" ? message : JSON.stringify(message);
  return `<a href="javascript:void(0)" data-feishu-support-desk-guide="${String(guideMessage).replace(/"/g, "&quot;")}" style="color: #409EFF;text-decoration: underline;cursor: pointer;display: inline-block;margin-left: 8px;">\u67E5\u770B\u64CD\u4F5C\u6307\u5BFC</a>`;
}
function buildErrorHtmlMessage(message, options = {}) {
  const text = message == null ? "" : String(message);
  if (!options.forceShow && !shouldShowFeishuSupportDeskGuide())
    return text;
  bindFeishuSupportDeskGuideClick();
  return `${text}${buildFeishuSupportDeskGuideHtml(text)}`;
}
export { buildErrorHtmlMessage };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/feishu/buildErrorHtmlMessage.js